<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :title="msgDialog ? msgDialog.title : ''"
    width="400px" class="message-dialog">
    <p class="msg-content">{{ msgDialog ? msgDialog.message : '' }}</p>
    <div class="msg-fd">
      <el-button @click="close" v-if="msgDialog && !msgDialog.hideClose" type="text" :class="{'btn-text__spring':isSpring}">取消</el-button>
      <el-button @click="commit" type="primary" style="margin-left: 30px;" size="medium"  :class="{'btn__spring':isSpring}">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState({
      msgDialog: state => state.msgDialog,
      isSpring: state => state.isSpring
    }),
    visible: {
      get() {
        const { msgDialog } = this

        if (msgDialog) {
          return true
        } else {
          return false
        }
      },
      set(val) {
        if (!val) {
          this.SETMSGDIALOG(null)
        }
      }
    },
  },
  methods: {
    ...mapMutations(['SETMSGDIALOG']),
    close() {
      this.SETMSGDIALOG(null)
    },
    commit() {
      const { msgDialog } = this

      msgDialog.commit && msgDialog.commit()
    },
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .msg-fd {
    text-align: right;
    padding-top: 30px;
  }
  ::v-deep .msg-content {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
</style>
<style lang="scss">
    .btn-text__spring{
        color:#333 !important;
    }
    .el-button--primary.btn__spring{
        background-color:$spring-color !important;
        border-color:$spring-color !important;
        &:hover,&:focus{
            background-color:$spring-color !important;
            border-color:$spring-color !important;
        }
    }
</style>
